<script setup lang="ts">
import HeaderRight from "./HeaderRight.vue";
import LayoutTopNavigationMobile from "~/components/layout/LayoutTopNavigationMobile.vue";

const { count } = useCart();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
const mobileNav = ref(null);

const handleMobileMenuToggle = () => {
  if (mobileNav.value) {
    mobileNav.value.toggleMenu();
  }
};
</script>

<template>
  <!-- Header Section -->
  <header class="z-30 block sticky top-0">
    <!-- Middle Header -->
    <div class="header-mid py-5 px-4 bg-dark-bg">
      <div class="container mx-auto">
        <div class="wrap flex justify-between items-center">
          <!-- Logo -->
          <div class="flex">
            <NuxtLink :to="formatLink(`/`)" class="inline-block">
              <img format="webp" class=" h-7 md:h-10 lg:h-12" src="assets/images/kisag-logo-web.png" alt="Logo" />
            </NuxtLink>
          </div>
          <div class="hidden md:block">
            <LayoutStoreSearch />
          </div>

          <HeaderRight @toggle-mobile-menu="handleMobileMenuToggle" />
        </div>
      </div>
    </div>

    <!-- Bottom Header -->
    <LayoutTopNavigation />

    <!-- Mobile Navigation -->
    <LayoutTopNavigationMobile ref="mobileNav" />
  </header>
  <!------ header ends here ------->
</template>
